import axios from 'axios'
import qs from 'qs'
import {
  Message
} from 'element-ui';

// 创建axios实例
const $http = axios.create({
  baseURL: process.env.API_BASEURL, // node环境的不同，对应不同的baseURL
  timeout: 5000, // 请求的超时时间
  //设置默认请求头，'application/json;charset=UTF-8'
  // headers: {  
  // "Content-Type": "application/x-www-form-urlencoded"
  // },
  withCredentials: true // 允许携带cookie
})


// 请求拦截
$http.interceptors.request.use(
  config => {
    return config;
  },
  error => {
    Message.error({
      message: '加载超时',
      type: 'error',
      duration: 5 * 1000
    });
  }
);

// 返回拦截
$http.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error.response === undefined || error.response.status === undefined) {
      Message({
        message: '服务器繁忙，请稍后重试!',
        type: 'error',
        duration: 2 * 1000,
        showClose: true,
      });
    } else if (error.response.status === 401 || error.response.status === 412) {
      Message({
        message: '加载超时!',
        type: 'error',
        duration: 2 * 1000
      });
    } else {
      Message({
        message: error.message,
        type: 'error',
        duration: 5 * 1000
      })
    }
  }
);

/**
 * formData格式axios
 */
function request(options) {
  return new Promise((resolve, reject) => {
    // 基本设置
    const instance = axios.create({
      baseURL: '',
      withCredentials: true, //携带cookie
    });

    // 请求拦截
    instance.interceptors.request.use(
      config => {
        if (config.method === 'post' || config.method === 'put') {
          config.data = qs.stringify(config.data);
          let token = sessionStorage.getItem("token")
          if (token) {
            config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
            config.headers['Authorization'] = 'Bearer' + ' ' + token;
          } else {
            config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
          }
        }
        return config;
      },
      error => {
        Message.error({
          message: '加载超时',
          type: 'error',
          duration: 5 * 1000
        });
        return Promise.reject(error)
      });
    // 返回拦截
    instance.interceptors.response.use(
      response => {
        return response
      },
      error => {
        if (error.response === undefined || error.response.status === undefined) {
          Message({
            message: '服务器繁忙，请稍后重试!',
            type: 'error',
            duration: 2 * 1000,
            showClose: true,
          });
        } else if (error.response.status === 401 || error.response.status === 412) {
          Message({
            message: '加载超时!',
            type: 'error',
            duration: 2 * 1000,
          });
        } else {
          Message({
            message: error.message,
            type: 'error',
            duration: 5 * 1000
          })
        }
        return Promise.reject(error) // 错误信息
      });
    //请求处理
    instance(options)
      .then((res) => {
        resolve(res.data);
        return false
      })
      .catch((error) => {
        reject(error)
      })
  })
}
/**
 * post请求
 * @param url 接口地址
 * @param data 参数（request payLoad）
 * @returns {Promise<R>|Promise<U>}
 */
function requestJsonPost(url, data) {
  let token = sessionStorage.getItem("token")
  let headers = {}
  if (token) {
    headers = {
      'Content-Type': 'application/json;charset=UTF-8',
      'Authorization': 'Bearer' + ' ' + token
    }
  } else {
    headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    };
  }
  const options = {
    headers: headers
  };
  return $http.post(url, data, options)
}
// 普通 form data
function requestFormPost(url, data) {
  return request({
    method: 'POST',
    url: url,
    data,
  });
}

const HttpRequest = {
  requestJsonPost,
  requestFormPost
};

export default HttpRequest;
